const SETUP_PROGRESS = {
  ADD_LINK: 'link',
  CHANGE_YOUR_DESIGN: 'design',
  SHARE_YOUR_PAGE: 'share',
  JOIN_COMMUNITY: 'join_community',
};

const SETUP_PROGRESS_IDS = {
  ADD_LINK: 'idf2fc5f9a-abf7-4124-8938-7646b3b6e9fa',
  CHANGE_YOUR_DESIGN: 'id123bc79d-0e9d-4b8f-9288-b84f8efd2d02',
  SHARE_YOUR_PAGE: 'idb1a45fc0-fca4-416b-8610-587306053be2',
  JOIN_COMMUNITY: 'community',
};

const SETUP_PROGRESS_MOBILE_IDS = {
  ADD_LINK: 'idf2fc5f9a-abf7-4124-8938-7646b3b6e9fa',
  CHANGE_YOUR_DESIGN: 'id123bc79d-0e9d-4b8f-9288-b84f8efd2d02',
  SHARE_YOUR_PAGE: 'idb1a45fc0-fca4-416b-8610-587306053be2',
  JOIN_COMMUNITY: 'community-mobile',
};

const SETUP_PROGRESS_MENU_ITEMS = [
  {
    label: 'Add something to your page',
    inputId: `input_id-${SETUP_PROGRESS_IDS.ADD_LINK}`,
    id: SETUP_PROGRESS_IDS.ADD_LINK,
    mobileId: SETUP_PROGRESS_MOBILE_IDS.ADD_LINK,
    to: { name: 'Links' },
    key: SETUP_PROGRESS.ADD_LINK,
  },
  {
    label: 'Design your page',
    inputId: `input_id-${SETUP_PROGRESS_IDS.CHANGE_YOUR_DESIGN}`,
    id: SETUP_PROGRESS_IDS.CHANGE_YOUR_DESIGN,
    mobileId: SETUP_PROGRESS_MOBILE_IDS.CHANGE_YOUR_DESIGN,
    to: { name: 'Design' },
    key: SETUP_PROGRESS.CHANGE_YOUR_DESIGN,
  },
  {
    label: 'Share your page',
    inputId: `input_id-${SETUP_PROGRESS_IDS.SHARE_YOUR_PAGE}`,
    id: SETUP_PROGRESS_IDS.SHARE_YOUR_PAGE,
    mobileId: SETUP_PROGRESS_MOBILE_IDS.SHARE_YOUR_PAGE,
    key: SETUP_PROGRESS.SHARE_YOUR_PAGE,
  },
  {
    label: 'Connect with the community',
    inputId: `input_id-${SETUP_PROGRESS_IDS.JOIN_COMMUNITY}`,
    id: SETUP_PROGRESS_IDS.JOIN_COMMUNITY,
    mobileId: SETUP_PROGRESS_MOBILE_IDS.JOIN_COMMUNITY,
    key: SETUP_PROGRESS.JOIN_COMMUNITY,
  },
];

export {
  SETUP_PROGRESS,
  SETUP_PROGRESS_IDS,
  SETUP_PROGRESS_MOBILE_IDS,
  SETUP_PROGRESS_MENU_ITEMS,
};
